module.exports = __webpack_public_path__ + "img/mail_sent2.74d646aa.svg";